import { sellerStateDocsIndexed } from '../data/states/stateData.js';
import { AssignmentStatus } from '../types/inventory/Assignment.js';
import { InventoryItemCondition, InventoryMatchingStatus } from '../types/inventory/InventoryItem.js';
import { Services } from '../types/servicesProviders/services/Services.js';

/**
 * Validates whether an inventory item is ready for online sale
 *
 * Checks the following criteria:
 * - Seller is live for online sales
 * - Seller state docs are indexed
 * - Item is NEW condition
 * - Matching status is MATCHED
 * - Retail price > 0
 * - VIN exists
 *
 * @param item - The inventory item or listing to validate
 * @param servicesProviderConfig - The services provider configuration
 * @returns true if the item meets all criteria for online sale, false otherwise
 */
function validateReadyForOnlineSale(item, inventoryServicesProvider) {
    if (!item || !inventoryServicesProvider.legalAddress?.state) {
        return false;
    }
    const sellerStateDocsAreReady = sellerStateDocsIndexed.includes(inventoryServicesProvider.legalAddress.state);
    const isSellerLiveForOnlineSales = inventoryServicesProvider.config?.[Services.INVENTORY]?.isLiveForOnlineSales;
    const isAvailable = item.assignment?.status === AssignmentStatus.AVAILABLE;
    return (
    // The inventory owner is live for online sales
    !!isSellerLiveForOnlineSales &&
        // We need to have the seller's state docs indexed
        sellerStateDocsAreReady &&
        // The item is available for sale (not locked in DMS)
        isAvailable &&
        // We're not ready to sell used vehicles
        item.newUsed === InventoryItemCondition.NEW &&
        // Need a fully matched canon vehicle variant
        item.matching?.status === InventoryMatchingStatus.MATCHED &&
        // Retail price determines cart price
        (item.pricing?.retailPrice ?? 0) > 0 &&
        // VIN is required for checkout
        !!item.vin &&
        item.vin.length > 0);
}

export { validateReadyForOnlineSale };
//# sourceMappingURL=inventoryValidation.js.map
